import type { StylesConfig } from 'react-select';

import type { SelectOption } from '@/components/filters/selectUtils';

type SelectTheme = {
  primary: string;
  soft: string;
  softAlt: string;
  text: string;
};

export const SELECT_THEMES: Record<'product' | 'customer' | 'orders' | 'forecast', SelectTheme> = {
  product: {
    primary: '#2563eb',
    soft: '#dbeafe',
    softAlt: '#eff6ff',
    text: '#1d4ed8',
  },
  customer: {
    primary: '#6b7280',
    soft: '#f3f4f6',
    softAlt: '#f9fafb',
    text: '#374151',
  },
  orders: {
    primary: '#d97706',
    soft: '#fef3c7',
    softAlt: '#fffbeb',
    text: '#b45309',
  },
  forecast: {
    primary: '#475569',
    soft: '#e2e8f0',
    softAlt: '#f1f5f9',
    text: '#334155',
  },
};

export function buildSelectStyles(theme: SelectTheme): StylesConfig<SelectOption, boolean> {
  return {
    control: (base, state) => ({
      ...base,
      minHeight: 40,
      borderColor: state.isFocused ? theme.primary : base.borderColor,
      boxShadow: state.isFocused ? `0 0 0 1px ${theme.primary}` : 'none',
      ':hover': {
        borderColor: state.isFocused ? theme.primary : base.borderColor,
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? theme.soft : state.isFocused ? theme.softAlt : base.backgroundColor,
      color: state.isSelected ? theme.text : base.color,
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: theme.soft,
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: theme.text,
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: theme.text,
      ':hover': {
        backgroundColor: theme.softAlt,
        color: theme.text,
      },
    }),
    menu: (base) => ({ ...base, zIndex: 60 }),
  };
}
